import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  galleryName = 'galleryGallery';

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/gallery/gallery.component.ts